import script from "./TheBreadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./TheBreadcrumbs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__